module.exports = __webpack_public_path__ + "img/homefooter_icon01.0f55d71a.png";